<script lang="ts">

	import "@lottiefiles/lottie-player";
	import { Route, Router } from 'svelte-navigator';
	import Home from './Pages/Home.svelte';
	import Map from './Pages/Map.svelte';
	import Menu from './Pages/Menu.svelte';
	import RouteForm from './Pages/RouteForm.svelte';
	import ShareScore from "./Pages/ShareScore.svelte";
	import { appColor } from './Services';

	let windowHeight: number = window.innerHeight;

</script>

<svelte:window bind:innerHeight={windowHeight} />

<Router --route-color={$appColor} --vh="{windowHeight}px" primary={false}>

	<Route path="/" component={Home} />
	<Route path="/menu" component={Menu} />
	<Route path="/ruta/:id" component={RouteForm} />
	<Route path="/mapa/*params" component={Map} />
	<Route path="/compartir" component={ShareScore} />

</Router>